<template>
  <v-app style="background-color:white">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

    <v-card class="form-container" flat>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-autocomplete
              v-model="selectedCategory"
              :items="categories"
              color="primary"
              label="Select Category *"
              item-text="categoryName"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
          </v-flex>
            <v-flex xs12>
                <v-text-field v-model="form.categoryName" label="Product Category Name *" :rules="emptyRule" required></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field v-model="form.delivery" label="Expected Delivery Time"></v-text-field>
            </v-flex>
          <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
            <v-btn depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
          </v-flex>
          
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create Counselling",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      dateModel: false,

      imagelink: null,
      imageError:'',

      //selectedFile: null,

      valid: true,

      image:{
      size:'',
      height:'',
      width:''
    },
    imageLoaded:false,

    date1: new Date(),

    categories: null,
      selectedCategory: null,


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Category",
          disabled: false,
          to: "/itemCategory"
        },
        {
          text: "Create",
          disabled: true,
          to: "/createStudent"
        }
      ],


      form: {
          categoryName: null,
          delivery: null
      }
    };
  },

  mounted() {
    this.axios
        .get(config.API + "Categories1", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.categories = res.data;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    selectedFile() {
      this.imageLoaded = false;
      this.imageError = '';

      let file = this.$refs.myFile.files[0];
      this.imagelink = file;
      if(!file || file.type.indexOf('image/') !== 0) return;
      
      this.image.size = file.size;

      if(this.image.size > 500000) {
        this.imageError = `The image size (${this.image.size}) is too much (max is 500 KB).`;
        return;
      }
      
      let reader = new FileReader();
      
      reader.readAsDataURL(file);
      reader.onload = evt => {
        let img = new Image();
        img.onload = () => {
          this.image.width = img.width;
          this.image.height = img.height;
          this.imageLoaded = true;
        }
        img.src = evt.target.result;
      }

      reader.onerror = evt => {
        console.error(evt);
      }
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Categories`,
            {
              parentId: JSON.parse(this.selectedCategory),
              categoryName: this.form.categoryName,
              delivery: this.form.delivery
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully added");
            //this.$router.push(`counsellingImage/${code}`);
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
</style>
